import { render, staticRenderFns } from "./data43.vue?vue&type=template&id=31479fd9&scoped=true&"
import script from "./data43.vue?vue&type=script&lang=js&"
export * from "./data43.vue?vue&type=script&lang=js&"
import style1 from "./data43.vue?vue&type=style&index=1&id=31479fd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31479fd9",
  null
  
)

export default component.exports